// extracted by mini-css-extract-plugin
module.exports =  {"connectButton":"button-module_connectButton_db10b","syncing":"button-module_syncing_b15ac"};